import { CsvImportReturnDto, CsvImportRowDto } from '@/endpoints/models'

import { ImportStructureProps } from '../../../hooks/useImport'

export type InputDataParsed = Papa.ParseResult<string[]>

export type CsvOnMapped = (
	data?: CsvImportRowDto[],
	importStructureProps?: ImportStructureProps,
	csvMapped?: boolean,
) => void

/** Field name to csv column index map */
export type CsvMapping = {
	[fieldName: string]: number | undefined
}
export interface CsvImporterContextState {
	checkResult?: CsvImportReturnDto,
	/** Names of tables which should be duplicated */
	createAnywayTableNames: string[],
	firstRow?: string[],
	formDataCheck?: ImportStructureProps,
	hasHeaders: boolean,
	inputDataParsed?: InputDataParsed,
	/** Mapping between csv column & field */
	mapping: CsvMapping,
	nodeId: number,
	/** Callback for parent component after mapping */
	onMapped: CsvOnMapped,
	/** Clear values set by onMapped callback  */
	resetImport: () => void,
	/** Mapped data */
	rows?: CsvImportRowDto[],
	step: CsvImporterStepEnum
}

export interface CsvImporterContextType {
	dispatch: React.Dispatch<Actions>,
	state: CsvImporterContextState
}

export enum CsvImporterStepEnum {
	PREVIEW,
	TABLE_BASICS,
	TABLE_EXTENDED,
	COLUMNS,
	CHECK,
}

export enum ActionTypeEnum {
	STEP_SET,
	FORM_DATA_CHECK_SET,
	ROWS_SET,
	CHECK_RESULT_SET,
	INPUT_DATA_PARSED_SET,
	HAS_HEADERS_SET,
	CSV_MAPPING_UPDATE,
	CREATE_ANYWAY_TABLE_NAMES_TOGGLE,
	CREATE_ANYWAY_TABLE_NAMES_SET,
}

type ActionChangeStep = {
	step: CsvImporterStepEnum,
	type: ActionTypeEnum.STEP_SET
}

type ActionFormDataCheckSet = {
	formDataCheck: ImportStructureProps,
	type: ActionTypeEnum.FORM_DATA_CHECK_SET
}

type ActionRowsSet = {
	rows: CsvImportRowDto[],
	type: ActionTypeEnum.ROWS_SET
}

type ActionCheckResultSet = {
	checkResult?: CsvImportReturnDto,
	type: ActionTypeEnum.CHECK_RESULT_SET
}

type ActionInputDataParsedSet = {
	inputDataParsed?: InputDataParsed,
	type: ActionTypeEnum.INPUT_DATA_PARSED_SET
}

type ActionHasHeadersSet = {
	hasHeaders: boolean,
	type: ActionTypeEnum.HAS_HEADERS_SET
}

type ActionCsvMappingUpdate = {
	mapping: CsvMapping,
	type: ActionTypeEnum.CSV_MAPPING_UPDATE
}

type ActionCreateAnywayTableNamesToggle = {
	createAnywayTableName: string,
	type: ActionTypeEnum.CREATE_ANYWAY_TABLE_NAMES_TOGGLE
}

type ActionCreateAnywayTableNamesSet = {
	createAnywayTableNames: string[],
	type: ActionTypeEnum.CREATE_ANYWAY_TABLE_NAMES_SET
}

export type Actions =
	| ActionChangeStep
	| ActionFormDataCheckSet
	| ActionRowsSet
	| ActionCheckResultSet
	| ActionInputDataParsedSet
	| ActionHasHeadersSet
	| ActionCsvMappingUpdate
	| ActionCreateAnywayTableNamesToggle
	| ActionCreateAnywayTableNamesSet
